import { render, staticRenderFns } from "./AnnotationBadges.vue?vue&type=template&id=798d7c09"
import script from "./AnnotationBadges.vue?vue&type=script&lang=ts"
export * from "./AnnotationBadges.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports